
export class RequestData {
  Token: string = "";
  UserName: string = "";
  Date: string = "";
  Id: number;
}
